import React from 'react'
import { Alert, Button, Stack, Typography } from '@mui/material'

export default function GanttLegacyBanner({ hiddenCount, onReview }) {
  if (!hiddenCount) return null

  return (
    <Alert
      severity="info"
      sx={{
        borderRadius: 2,
        alignItems: 'center',
        backgroundColor: '#EFF8FF',
        border: '1px solid #B2DDFF',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'flex-start', md: 'center' }}
        justifyContent="space-between"
        spacing={1.5}
        width="100%"
      >
        <Typography variant="body2" sx={{ color: '#175CD3', fontWeight: 500 }}>
          {hiddenCount} legacy task{hiddenCount > 1 ? 's are' : ' is'} hidden from the Gantt chart
          because the working period is missing.
        </Typography>

        <Button size="small" variant="outlined" onClick={onReview} sx={{ textTransform: 'none', borderRadius: 999 }}>
          Review Tasks
        </Button>
      </Stack>
    </Alert>
  )
}
